module.exports = __webpack_public_path__ + "img/chevron-down.0d40a078.svg";